import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "@/components/Errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const intl = useIntl();
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  return (
    <PageError
      title={
        variant === "flight"
          ? intl.formatMessage({ id: "flights.notAvailable.title" })
          : intl.formatMessage({ id: "hotels.notAvailable.title" })
      }
      subtitles={[
        variant === "flight"
          ? intl.formatMessage({ id: "flights.notAvailable.description" })
          : intl.formatMessage({ id: "hotels.notAvailable.description" }),
      ]}
      back={{
        text:
          variant === "flight"
            ? intl.formatMessage({ id: "flights.notAvailable.button" })
            : intl.formatMessage({ id: "hotels.notAvailable.button" }),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
